<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates37">
<p class="centerImage"><img alt="images" id="plate37" src="images/plate37.jpg"/></p>
<p class="caption">Bill Gibbs’ fitter, identified by the screwdriver, talks to RWF, McIntyre and Bill. Bill usually flew Spitfire DL-K.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates37.vue?29087000